define(function (require) {
    var ko = require("knockout");
    var _ = require("underscore");
    var scanTranslations = require("scanTranslations");

    var dataLayerService = require("@modules/services/dataLayerService");
    var querystring = require("querystring");
    var loadedQuerystring = querystring.parse();

    return function (parent, data, lat, lng, isDrx) {
        var self = this;

        self.providerId = ko.observable(data.ProviderId);
        self.practitionerId = ko.observable(data.Id);
        self.lastName = ko.observable(data.LastName);
        self.firstName = ko.observable(data.FirstName);
        self.middleName = ko.observable(data.MiddleName);
        self.middleInitial = ko.observable(data.MiddleInitial);
        self.suffixName = ko.observable(data.SuffixName);
        self.fullName = ko.observable(data.SearchResultsDisplayName);
        self.title = ko.observable(data.Title);
        self.phone = ko.observable(data.Phone);
        self.gender = ko.observable(data.Gender);
        self.address1 = ko.observable(data.Address1);
        self.address2 = ko.observable(data.Address2);
        self.city = ko.observable(data.City);
        self.state = ko.observable(data.State);
        self.zip = ko.observable(data.Zip);
        self.isAcceptingNewPatients = ko.observable(data.IsAcceptingNewPatients);
        self.distance = ko.observable(data.Distance);
        self.specialties = ko.observableArray(data.Specialties);
        self.isMultipleGroups = isNaN(data.GroupNames) ? false : Number(data.GroupNames) > 1;
        self.medicalGroupCount = ko.observable(data.MedicalGroupCount);
        self.locationCount = ko.observable(data.LocationCount);
        //self.groupNames = ko.observable(isNaN(data.GroupNames) ? 0 : Number(data.GroupNames));
        self.role = ko.observable(data.Role);

        self.pcponly = ko.observable(data.PcpOnly);
        self.inofficevisits = ko.observable(data.InOfficeVisits);
        self.mobileonly = ko.observable(data.MobileOnly);
        self.mobileavailable = ko.observable(data.MobileAvailable);
        self.telehealthonly = ko.observable(data.TelehealthOnly);
        self.telehealthavailable = ko.observable(data.TelehealthAvailable);
        self.lgbtqplus = ko.observable(data.LGBTQPlus);

        self.languages = ko.observable(data.Languages);
        self.languageList = ko.computed(function () {
            return self.languages().length > 0 ? self.languages().join(", ") : "";
        });

        var isGuidedEnrollment = $("#guided-enrollment").length > 0;
        var isPBPChange = $("#member-pbp").length > 0;

        self.disabledSelect = ko.computed(function () {});

        self.hasSpecialties = ko.computed(function () {
            return self.specialties().length > 0;
        });

        self.telHref = ko.computed(function () {
            return self.phone() ? "tel:" + self.phone().replace(/[^\d]/g, "") : null;
        });

        // self.mapUrl = ko.computed(function () {
        //     var segments = [self.address1(), self.address2(), self.city(), self.state(), self.zip()];
        //
        //     var search = _.chain(segments).compact().value().join(",");
        //
        //     return "https://www.google.com/maps/search/" + encodeURIComponent(search);
        // });

        self.showSelectButton = ko.computed(function () {
            var result = (isDrx && (self.role() === "PCP" || self.role() === "BOTH")) || parent.selectPcp() || parent.goewPbp() === true;
            if (isGuidedEnrollment || isPBPChange) {
                result = true;
            }
            return result;
        });

        self.buttonIsDisabled = ko.computed(function () {
            return parent.currentPcpId() === self.providerId() && parent.selectPcp();
        });

        self.buttonText = ko.observable();

        function asyncComputed(evaluator, owner) {
            var result = ko.observable();
            ko.computed(function () {
                evaluator.call(owner).done(result);
            });
            return result;
        }
        this.queryResults = asyncComputed(function () {
            return scanTranslations.getInstance().then(function (scanTranslationInstance) {
                var selectButtonTextKey = "";
                if (parent.currentPcpId() === self.providerId()) {
                    selectButtonTextKey = "your_current_pcp";
                } else {
                    selectButtonTextKey = "select_this_provider";
                }
                if (isGuidedEnrollment || isPBPChange) {
                    selectButtonTextKey = "onlineenrollment_continue";
                }
                self.buttonText(scanTranslationInstance.translate(selectButtonTextKey));
            });
        }, this);

        /*
                    return scanTranslations.getInstance().then(function (scanTranslationInstance) {
                        if (parent.currentPcpId() === self.providerId()) {
                            self.buttonText(scanTranslationInstance.translate("your_current_pcp"));
                        }
                        self.buttonText(scanTranslationInstance.translate("select_provider"));
                    });
        */

        self.detailLinkText = ko.computed(function () {
            var text = self.showSelectButton() ? "Select " : "View ";

            text += self.firstName() + " ";

            if (self.middleInitial()) {
                text += self.middleInitial() + ". ";
            }

            text += self.lastName();

            if (self.suffixName()) {
                text += ", " + self.suffixName();
            }

            if (!self.showSelectButton()) {
                text += "'s Details";
            }

            return text;
        });

        self.viewDetails = function () {
            var isFindMyPcp = loadedQuerystring["findmypcp"];
            if (isFindMyPcp != undefined) {
                var dataLayerEvent = {
                    event: "PCPFinder",
                    step_name: "select provider",
                    step_number: "1"
                };
                dataLayerService.pushEventToGtmDataLayer(dataLayerEvent);
            }
            parent.viewDetails(self.providerId(), self.practitionerId(),lat, lng);
        };
    };
});
